import { StoreTooltip } from '@libs/shared-ui';
import type { StockStatusEnum } from '@petsmart-ui/sparky';
import { StockStatusLabel } from '@petsmart-ui/sparky';

type StoreInfoProps = {
    stockStatus: StockStatusEnum;
};

export default function StoreInfo({ stockStatus }: StoreInfoProps) {
    return (
        <div className="in-store-only__stock-status">
            <StockStatusLabel
                stockStatus={stockStatus}
                labelInStock="In stock at"
                labelFewLeftInStock="Only a few in stock at"
                labelOutOfStock="Out of stock at"
            />
            <div className="in-store-only__store-address">
                <StoreTooltip />
            </div>
        </div>
    );
}
